import { VinnovaStatus } from './vinnova-status.model';

export interface Account {
  id?: string;
  number: string;
  swift?: string;
  iban?: string;
  bsbCode?: string;
  routingNumber?: string;
  fw?: string;
  type: AccountType;
  vinnovaStatus?: VinnovaStatus;
  worksiteId?: string;
  companyId?: string;
  country: string;
  existOnSameCompany?: boolean;
  companyName?: string;
}

export enum AccountType {
  PlusGiro,
  BankGiro,
  Utlandskonto,
}
